// removed by extract-text-webpack-plugin
module.exports = {"container":"_20ADDTooRerblyPtOEfmyl","searchContainer":"_2fZFqYKjqhQNqnkdNj7q_o","filterContainer":"_3xdfuONqB7qQekLfnG-xJL","productPmsContainer":"_2Ipke9Rm-OfeA-CdIoaTxD","activeCheckboxContainer":"ER5x4Z-fcS6Dy7PxEbZMm","productsButton":"UAiucPpUvagYElm0ef8dr","pmsButton":"GJuwHS17X7qy6Sr9EhaVj","productList":"_2NmSC9IyYN-HmG8AVD-evJ","numPractices":"DjGkTXuaSo3h-ldOuM57I","clearButton":"_1d8ojIhEsiNDV9EjeBOhDo","customInput":"_1IkU6OMXdAIoCsKcMjFYnk","ant-input-group-addon":"_2sClRsc2r20wVE1zguEl0Q","searchInput":"_3NcE30uzQkVn007MNhnpkY"};


//////////////////
// WEBPACK FOOTER
// ./src/Dashboard/Filters/filter.css
// module id = 69
// module chunks = 0